import React, { forwardRef } from 'react';
import { cn } from '../utils/cn';
import { motion, HTMLMotionProps } from 'framer-motion';
interface ButtonProps extends Omit<HTMLMotionProps<'button'>, 'ref'> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
}
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  className,
  variant = 'primary',
  size = 'md',
  children,
  ...props
}, ref) => {
  const variants = {
    primary: 'bg-terracotta text-cream hover:bg-terracotta/90',
    secondary: 'bg-forest text-cream hover:bg-forest/90',
    outline: 'border-2 border-charcoal text-charcoal hover:bg-charcoal hover:text-cream',
    ghost: 'text-charcoal hover:bg-charcoal/5'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg font-medium'
  };
  return <motion.button ref={ref} whileHover={{
    y: -2
  }} whileTap={{
    y: 0
  }} className={cn('inline-flex items-center justify-center rounded-none transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-saffron focus-visible:ring-offset-2 focus-visible:ring-offset-cream disabled:opacity-50 disabled:pointer-events-none', variants[variant], sizes[size], className)} {...props} data-id="element-11">
        {children}
      </motion.button>;
});
Button.displayName = 'Button';